import { __makeTemplateObject } from "tslib";
import { css } from '../styled-components';
import { palette2, getParsePaletteColor } from './newPalette';
import { radius } from './radius';
var focusRingOffsetMap = {
    normal: '2px',
    inset: '0px',
};
export var focusRing = function (variant, options) {
    if (options === void 0) { options = {}; }
    var _a = options.pseudo, pseudo = _a === void 0 ? true : _a;
    if (pseudo) {
        var _b = options.borderRadius, borderRadius = _b === void 0 ? 'zero' : _b, _c = options.borderWidth, borderWidth = _c === void 0 ? '0px' : _c;
        var isInset = variant === 'inset';
        var offset = focusRingOffsetMap[variant];
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      &:after {\n        pointer-events: none;\n        content: '';\n        position: absolute;\n        inset: 0;\n\n        margin: calc(-", " - ", ");\n        border-radius: calc(", " + ", ");\n        box-shadow: ", " 0 0 0 2px\n          ", ";\n      }\n    "], ["\n      &:after {\n        pointer-events: none;\n        content: '';\n        position: absolute;\n        inset: 0;\n\n        margin: calc(-", " - ", ");\n        border-radius: calc(", " + ", ");\n        box-shadow: ", " 0 0 0 2px\n          ", ";\n      }\n    "])), offset, borderWidth, offset, radius(borderRadius), isInset ? 'inset' : '', palette2('interactive', 'f01'));
    }
    var _d = options.gapColor, gapColor = _d === void 0 ? 'neutral.b01' : _d;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-shadow: 0 0 0 2px ", ",\n      0 0 0 4px ", ";\n  "], ["\n    box-shadow: 0 0 0 2px ", ",\n      0 0 0 4px ", ";\n  "])), getParsePaletteColor(gapColor), palette2('interactive', 'f01'));
};
var templateObject_1, templateObject_2;
